
import { defineComponent, nextTick, watch, ref } from 'vue'
export default defineComponent({
  props: {
    msg: String,
  },
  setup(props, context) {
    let pop: HTMLElement | null = null
    const popMsg = ref()
    const getPop: (el: HTMLElement) => void = el => {
      pop = el
    }
    const popMe: (msg: string, delay: number) => void = (msg, delay) => {
      ;(pop as HTMLElement).style.transform = 'translateY(0)'
      setTimeout(() => {
        ;(pop as HTMLElement).style.transform = 'translateY(-100%)'
      }, delay)
    }
    watch(
      () => props.msg,
      (val, oval) => {
        popMsg.value = val
        popMe(val as string, 1000)
      }
    )
    return { getPop, popMsg }
  },
})
